exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-026ba7e3]{margin-bottom:16px;color:#17233d;font-weight:500;font-size:14px}.description-term[data-v-026ba7e3]{display:table-cell;padding-bottom:10px;line-height:20px;width:50%;font-size:12px}\n", ""]);

// exports
